	<app-form-view [popup]="'true'" [contentLoader]="loader" (helpTriggered)="helpTriggered = $event">
		<form-title>
			{{formTitle}}
		</form-title>
		<content-area>
			<div class="question-forms" fxLayout="column" fxLayoutAlign="start stretch">
				<ng-container *ngIf="!formLoader">
					<div fxLayout="row" fxLayoutAlign="center center">
						<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="0 1 586px" fxFlex.xs="100" fxLayoutGap="15px">
							<div fxLayout="column" fxLayoutAlign="start stretch" class="form-container">
								<app-form-group [fieldList]="[title]" [config]="config" [formObjectData]="formObjectData"
									fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
									fxLayoutGap="10px" fxLayoutGap.xs="10px" (formObject)="formObjectReader($event)"></app-form-group>
								<ng-container *ngIf="showDescription">
									<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
										<p class="card-title hyperlink" (click)="addDescription(description?.fieldColumn)">
											{{locale.translate('add_a_description')}}</p>
									</div>
								</ng-container>
								<app-form-group [fieldList]="[description]" [config]="config" [formObjectData]="formObjectData"
									fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
									fxLayoutGap="10px" fxLayoutGap.xs="10px" (formObject)="formObjectReader($event)"></app-form-group>
							</div>
							<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
								<ng-container *ngIf="skillFormFields?.length">
									<div class="block-title"> {{ locale.translate('related_skills') }} </div>
								</ng-container>
								<div fxLayout fxLayoutAlign="center start" class="form-container">
									<app-form-group [fieldList]="skillFormFields" [formObjectData]="formObjectData" [config]="config"
										fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
										fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)">
									</app-form-group>
								</div>
							</div>
							<ng-container *ngIf="showUser">
								<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
									<div [ngClass]="([null, undefined].includes(experts)) ? 'hyperlink' : 'block-title linkable'"
										(click)="tagExperts('#experts')">
										{{ locale.translate('tag_experts') }} </div>
									<ng-container *ngIf="experts">
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="[experts]" [formObjectData]="formObjectData" [config]="config"
												fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
												fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
												(formObject)="formObjectReader($event)">
											</app-form-group>
										</div>
									</ng-container>
								</div>
							</ng-container>
							<ng-container *ngIf="action === 'addQuestion'">
								<app-collapsible-area [data]="{title: locale.translate('publish')}"
									[toggle]="{expanded: true, showToggle: true}" color="#fff">
									<div class="visibility-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<span class="visibility-desc">
											{{locale.translate('select_channels_to_publish_if_not_published_desc')}}
										</span>
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="visibilityField" [formObjectData]="formObjectData" [config]="config"
												fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
												fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
												(formObject)="formObjectReader($event)">
											</app-form-group>
										</div>
									</div>
								</app-collapsible-area>
							</ng-container>
							<div fxLayout="column" fxLayoutAlign="start stretch">
								<app-alert id="add-alert"></app-alert>
								<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
									<ng-container *ngIf="['addQuestion', 'editQuestion'].includes(action)">
										<!-- <button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
											type="button">{{locale.translate('submit')}}</button> -->
										<!-- <ng-container *ngIf="showUser">
											<button class="icon-btn" mat-icon-button (click)="navigateToBack()" [disabled]="submitDisable">
												<mat-icon>arrow_back</mat-icon>
											</button>
										</ng-container> -->
										<button class="icon-btn" mat-icon-button (click)="done()" [disabled]="submitDisable">
											<mat-icon>{{(showUser) ? 'done' : 'arrow_forward'}}</mat-icon>
										</button>
									</ng-container>
									<!-- <ng-container *ngIf="action === 'editQuestion'">
										<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
											type="button">{{locale.translate('update')}}</button>
									</ng-container> -->
									<!-- <button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
										type="button">{{locale.translate('cancel')}}</button> -->
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</content-area>
		<insights>
			<app-help></app-help>
		</insights>
	</app-form-view>
